import Vue from "vue";

let els;

if ((els = document.querySelectorAll(".about-steps")).length > 0) {
  for (let i = 0; i < els.length; i++) {
    const el = els[i];

    new Vue({
      el,
      name: "AboutSteps",
      data() {
        return {
          cities: [],
          opened: false,
          time: 1100,
          current_step: -1,
          current_step_show: 0,
          steps: window.passdata.template.aboutUs.step.steps,
        };
      },
      methods: {
        getImage: window.getImage,
        nextStep() {
          if (this.current_step === 4) {
            this.current_step = 0;
          } else {
            this.current_step += 1;
          }
          setTimeout(this.nextStep, this.time);
        },
        getDelay(index) {
          return 50;
        },
        nextStepBlock() {
          if (this.current_step_show === 4) {
            this.current_step_show = 4;
          } else {
            this.current_step_show += 1;
            setTimeout(
              this.nextStepBlock,
              this.getDelay(this.current_step_show)
            );
          }
        },
      },
      mounted() {
        const el = document.querySelector("#about-steps");
        const observer = new window.IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setTimeout(this.nextStep, 3000);
              setTimeout(this.nextStepBlock, this.getDelay(0));
            }
          },
          {
            root: null,
            threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
          }
        );

        observer.observe(el);

        // setTimeout(this.nextStep, this.time);
      },
    });
  }
}
